
import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import WhyRaysSportsSection from './components/WhyRaysSportsSection';
import ProductsSection from './components/ProductsSection';
import ServicesSection from './components/ServicesSection';
import CoachingSection from './components/CoachingSection';
import RaysEyeSection from './components/RaysEyeSection';
import RaysVenueSection from './components/RaysVenueSection';
import ClubManagementSection from './components/ClubManagementSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <main className={`transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      <HeroSection />
      <WhyRaysSportsSection />
      <ProductsSection />
      <ServicesSection />
      <CoachingSection />
      <RaysEyeSection />
      <RaysVenueSection />
      <ClubManagementSection />
      <ContactSection />
    </main>
  );
}
